// hooks/useBeforeUnload.ts
import { onBeforeUnmount, onMounted } from 'vue';

export function useBeforeUnload(callback: (event: BeforeUnloadEvent) => void) {
    onMounted(() => {
        window.addEventListener('beforeunload', callback);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('beforeunload', callback);
    });
}
